// extracted by mini-css-extract-plugin
export default {"scriptBox":"ScriptBox_scriptBox__9Naxx","msg":"ScriptBox_msg__MA3fX","h3":"ScriptBox_h3__fETsK","chatIcon":"ScriptBox_chatIcon__zC07n"};